const formatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
});

export const formatNumber = (n: number) => {
  return formatter.format(n);
};
